import { ReactNode } from 'react';

import { User } from '@ergeon/erg-auth';

import authService from '../../utils/auth';

import Auth from './Auth';
import AuthWrapperContent from './AuthWrapperContent';

type AuthWrapperProps = {
  children: ReactNode;
};

const AuthWrapper = ({ children }: AuthWrapperProps) => (
  <section
    data-testid="auth-wrapper">
    <Auth authService={authService}>
      {(user: User) => <AuthWrapperContent user={user}>{children}</AuthWrapperContent>}
    </Auth>
  </section>
);

export default AuthWrapper;
